import reduce from 'lodash/reduce';

const row1 = [
  { name: '1', character: '1' },
  { name: '2', character: '2' },
  { name: '3', character: '3' }
];

const row2 = [
  { name: '4', character: '4' },
  { name: '5', character: '5' },
  { name: '6', character: '6' }
];

const row3 = [
  { name: '7', character: '7' },
  { name: '8', character: '8' },
  { name: '9', character: '9' }
];

const row4 = [
  { name: '0', character: '0' },
  { name: 'clear', character: 'clear', special: 'clear' }
];

const keys = {
  row1: ['1', '2', '3'],
  row2: ['4', '5', '6'],
  row3: ['7', '8', '9'],
  row4: ['0', 'clear']
};

export const keyLayout = [
  { name: 'row1', order: 0, keys: row1 },
  { name: 'row2', order: 1, keys: row2 },
  { name: 'row3', order: 2, keys: row3 },
  { name: 'row4', order: 3, keys: row4 }
].sort((a, b) => a.order > b.order);

export default keys;

const createMap = () => {
  const map = {};

  return {
    set(key, value) {
      map[key] = value;
    },

    get(key) {
      return map[key];
    }
  };
};

export const characterMap = reduce(
  keys,
  (mapAcc, chars, rowName) => {
    chars.forEach(char => mapAcc.set(char, rowName));

    return mapAcc;
  },
  createMap()
);
